import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Divider,
  Button,
  Chip,
  FormHelperText,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

const Seo = ({ values, handleChange, setFieldValue, touched, errors }) => {
  const [keywordInput, setKeywordInput] = useState("");

  const addKeyword = () => {
    const kw = keywordInput.trim();
    if (kw && !values.keywords.includes(kw)) {
      setFieldValue("keywords", [...values.keywords, kw]);
      setKeywordInput("");
    }
  };

  const removeKeyword = (kw) => {
    const updatedKeywords = values.keywords.filter((k) => k !== kw);
    setFieldValue("keywords", updatedKeywords);
  };

  const handleFieldChange = (field, value) => {
    setFieldValue(field, value);
    // if (field === "trending") {
    //   setFieldValue("trending", value ? "active" : "inactive");
    // } else {
    //   setFieldValue(field, value);
    // }
  };

  return (
    <>
      <Divider sx={{ my: 3 }} />
      {/* <Typography variant="h6" gutterBottom>
        SEO Settings
      </Typography> */}

      <FormControlLabel
        control={
          <Checkbox
            checked={values.trending === true}
            onChange={(e) => handleFieldChange("trending", e.target.checked)}
          />
        }
        label="Do you want to add this to trending listing?"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={values.isAvailable === true}
            onChange={(e) => handleFieldChange("isAvailable", e.target.checked)}
          />
        }
        label="Product status (Active/Inactive)"
      />

      {/* Meta Title */}
      <TextField
        label="Meta Title"
        name="metaTitle"
        value={values.metaTitle}
        onChange={handleChange}
        fullWidth
        margin="normal"
        error={touched.metaTitle && Boolean(errors.metaTitle)}
        helperText={touched.metaTitle && errors.metaTitle}
      />

      {/* Meta Description */}
      <TextField
        label="Meta Description"
        name="metaDescription"
        value={values.metaDescription}
        onChange={handleChange}
        fullWidth
        margin="normal"
        multiline
        rows={3}
        error={touched.metaDescription && Boolean(errors.metaDescription)}
        helperText={touched.metaDescription && errors.metaDescription}
      />

      {/* Keyword Input */}
      <Box display="flex" alignItems="center" gap={1} mt={2}>
        <TextField
          label="Add Keyword"
          value={keywordInput}
          onChange={(e) => setKeywordInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              addKeyword();
            }
          }}
          fullWidth
        />
        <Button onClick={addKeyword} variant="contained">
          Add
        </Button>
      </Box>

      {/* Keyword Chips */}
      <Box sx={{ mt: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
        {values.keywords.map((k) => (
          <Chip key={k} label={k} onDelete={() => removeKeyword(k)} />
        ))}
      </Box>

      {/* Keyword Error */}
      {touched.keywords && errors.keywords && (
        <FormHelperText error sx={{ mt: 1 }}>
          {errors.keywords}
        </FormHelperText>
      )}
    </>
  );
};

export default Seo;
